module.exports = __webpack_public_path__ + "static/media/feedback.33f5f63c.png";